import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Button from '@mui/material/Button';
import PrintIcon from '@mui/icons-material/Print';
import { useTranslation } from 'react-i18next';
import styles from '@/modules/general-notes/styles.less';

const PrintNotes = ({ notes = [] }) => {
  const { t } = useTranslation();
  const [isPrintVisible, setIsPrintVisible] = useState(false);

  useEffect(() => {
    if (!isPrintVisible) return undefined;

    const handleAfterPrint = () => {
      setIsPrintVisible(false);
    };

    window.addEventListener('afterprint', handleAfterPrint);

    const timer = window.setTimeout(() => {
      window.print();
    }, 0);

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
      window.clearTimeout(timer);
    };
  }, [isPrintVisible]);

  return (
    <>
      <Button
        variant="outlined"
        color="success"
        type="button"
        onClick={() => setIsPrintVisible(true)}
        startIcon={<PrintIcon />}
      >
        {t('Print')}
      </Button>
      {isPrintVisible &&
        createPortal(
          <div className={styles.printOverlay}>
            <div className={styles.printLayout}>
              {notes.map((note) => (
                <div className={styles.printNote} key={`print-${note.id}`}>
                  <h4 className={styles.printNoteTitle}>{note.title}</h4>
                  {note.items.length > 0 && (
                    <div className={styles.printNoteItems}>
                      {note.items.map((item) => (
                        <div
                          className={styles.printNoteItem}
                          key={`${note.id}-${item.id ?? item.label}`}
                        >
                          <span
                            className={
                              item.done
                                ? `${styles.printNoteCheckbox} ${styles.printNoteCheckboxChecked}`
                                : styles.printNoteCheckbox
                            }
                          />
                          <span className={styles.printNoteItemLabel}>
                            {item.label}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default PrintNotes;
